<template>
  <div class="main-height bg-white layout dashboard__layout height-fixed">
    <span @click="closeWidgetOnBoarding" title="close" class="close clickable pt-2 pr-2">
      <i class="icon icon-cancel text-dark6 ml-2"></i>
    </span>
    <div class="content">
      <img class="content__icon" :src="iconChecked" alt="success icon"/>
      <span class="content__description text-center heading-h6-14-medium pl-4 pr-4 pt-2">
        {{ $t("newonboarding.widget.successStep.description") }}
      </span>
      <span class="content__email body-12-regular pt-1">
        {{ $t("newonboarding.widget.successStep.button") }}
      </span>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import {actions as obActions} from "@/store/newonboarding/types";

export default {
  name: "Step4",
  props: {
    iconChecked: String
  },
  methods: {
    ...mapActions("newonboarding", {
      closeWidgetOnBoarding: obActions.CLOSE_WIDGET_ON_BOARDING
    }),
  }
}
</script>

<style lang="scss" scoped>
.close {
  display: flex;
  justify-content: right;
  cursor: pointer;
}

.content {
  display: flex;
  height: 100%;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  &__icon {
    width: 36px;
    height: 36px;
  }

  &__description {
    color: $textLightModeHigh;
  }

  &__email {
    color: $dark6;
  }
}

.height-fixed {
  min-height: 340px;
  display: flex;
  flex-direction: column;
}
</style>
